import { useGetBrokerageAnalyticsQuery } from "../dashBoardApi";
import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";
import useTranslator from "../../../hooks/useTranslator";
import { formatNumber } from "../../../helpers/Utils";
import { useEffect } from "react";

const BrokerageOverview = ({ startDate, endDate }) => {
  const { _t } = useTranslator();

  const {
    data: brkData,
    isLoading: isBrkDataLoading,
    refetch : brkDataRefetch
  } = useGetBrokerageAnalyticsQuery(
    { startDate, endDate },
    { skip: !startDate || !endDate }
  );

  const respData = brkData?.data;
  const boxes = [
    { key: "total_entered_kg",       label: _t("total_entered_kg_db",       "Total Entered KG"),       value: formatNumber(respData?.total_entered_kg) ?? 0,       theme: "orange" },
    { key: "total_sorted_kg",        label: _t("total_sorted_kg_db",        "Total Sorted (KG)"),      value: formatNumber(respData?.total_sorted_kg) ?? 0,        theme: "orange" },
    { key: "total_boxes_packed",     label: _t("total_boxes_packed_db",     "Total Boxes Packed"),     value: formatNumber(respData?.total_boxes_packed) ?? 0,     theme: "green"  },
    { key: "total_pasted_boxes_packed", label: _t("total_paste_boxes_packed_db", "Total Paste Boxes Packed"), value: formatNumber(respData?.total_pasted_boxes_packed) ?? 0, theme: "green" },
    { key: "total_rejected_kg",      label: _t("kg_rejected_db",            "KG Rejected"),            value: formatNumber(respData?.total_rejected_kg) ?? 0,      theme: "red"    },
  ];

  useEffect(() => {
    brkDataRefetch();
  }, []);

  return (
    <DashboardCard
      title={_t("brokerage_overview_db", "Brokerage Overview")}
      badgeIcon={startDate && endDate
        ? <span className="pko-batch-badge">{startDate} → {endDate}</span>
        : null
      }
    >
      <div className="fqm-grid">
        {boxes.map((b) => (
          <div key={b.key} className={`pp-brokering-box bro-box-${b.theme}`}>
            <div className="pp-brokering-box-label">{b.label}</div>
            <div className="pp-brokering-box-value">
              {isBrkDataLoading
                ? <span className="db-shimmer" style={{ height: 28, width: 60, display: "block" }} />
                : (b.value?? "0")
              }
            </div>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
};

export default BrokerageOverview;
